import { Flex } from "antd";
import { Progress } from "antd";
import { motion } from "framer-motion";
import { useFormContext } from "../../Contexts/FormContext.jsx";
import { Image } from "antd";
import { useFormEditorContext } from "../../Contexts/FormEditorContext.jsx";

export const FormHeader = () => {
    const { percentage, isInitialPage, isEndPage, formTheme, formSettings } =
        useFormContext();
    const { theme } = useFormEditorContext();
    const isFormEditor = location.pathname.includes("form-editor");
    const constTheme = isFormEditor ? theme : formTheme;
    const showProgressBar = formSettings?.show_progress_bar;

    const strokeColor = constTheme?.button_color;

    return (
        <FormHeaderFormat
            showPercentage={!isInitialPage && !isEndPage}
            percentage={percentage}
            strokeColor={strokeColor}
            showProgressBar={showProgressBar}
        />
    );
};

export const FormHeaderFormat = ({
    showPercentage,
    percentage,
    strokeColor,
    showProgressBar,
}) => {
    const { theme } = useFormEditorContext();

    return (
        <Flex className="fill-available" vertical>
            {showPercentage && showProgressBar && (
                <Progress
                    style={{
                        width: "100%",
                        margin: "3px 0 0 0",
                        alignSelf: "center",
                        padding: "0 14px",
                    }}
                    size={"small"}
                    percent={percentage}
                    type="line"
                    showInfo={false}
                    strokeColor={strokeColor}
                />
            )}
            <Flex
                style={{
                    padding: "10px",
                    paddingLeft: "26px",
                    justifyContent: "start",
                }}
            >
                <motion.div
                    key={"form-header-logo"}
                    initial={{ opacity: 0, translateY: 20 }}
                    animate={{ opacity: 1, translateY: 0 }}
                    style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-start",
                    }}
                >
                    {theme?.branding_logo_link && (
                        <Image
                            preview={false}
                            src={theme?.branding_logo_link}
                            height={60}
                            style={{
                                width: "auto",
                                maxWidth: "100%",
                                objectFit: "contain",
                                objectPosition: "left",
                            }}
                        />
                    )}
                </motion.div>
            </Flex>
        </Flex>
    );
};
